<template>
  <div class="section-parameter" v-if="infos">
    <div class="col-left">
      <h2>{{ $t('settings.media.title') }}</h2>
      <span>{{ $t('settings.media.message') }}</span>
    </div>
    <div class="col-right">
      <div class="form-group">
        <label>{{ $t('settings.media.badges') }}</label>
      </div>
      <div class="form-group two-columns">
        <div class="col">
          <img class="settings-image" :src="site.defaultmedia.achievement.url">
        </div>
        <div class="col">
          <el-upload
            :show-file-list="false"
            :action="api + '/media/default/achievement/'"
            :headers="headers"
            :on-success="loadNewImage">
            <el-button size="small" plain>{{ $t('settings.media.button') }}</el-button>
            <div slot="tip" class="el-upload__tip">{{ $t('settings.media.buttonmessage') }}</div>
          </el-upload>
        </div>
      </div>
      <div class="form-group">
        <label>{{ $t('settings.media.users') }}</label>
      </div>
      <div class="form-group two-columns">
        <div class="col">
          <img class="settings-image" :src="site.defaultmedia.user.url">
        </div>
        <div class="col">
          <el-upload
            :show-file-list="false"
            :action="api + '/media/default/user/'"
            :headers="headers"
            :on-success="loadNewImage">
            <el-button size="small" plain>{{ $t('settings.media.button') }}</el-button>
            <div slot="tip" class="el-upload__tip">{{ $t('settings.media.buttonmessage') }}</div>
          </el-upload>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      infos: null,
      api: process.env.API
    }
  },
  computed: {
    ...mapGetters('account', {
      site: 'currentSite'
    }),
    headers () {
      if (this.site) {
        return {'X-Token': localStorage.getItem('token'), 'X-Instance': this.site.sitekey}
      } else {
        return {}
      }
    }
  },
  watch: {
    site: function (site) {
      this.init()
    }
  },
  methods: {
    ...mapActions('account', ['updateSite']),
    init () {
      if (this.site) {
        this.infos = Object.assign({}, {
          id: this.site.id,
          defaultmedia: this.site.defaultmedia
        })
      }
    },
    loadNewImage () {
      this.infos.defaultmedia.achievement.url += '?rand=' + Math.random()
      this.infos.defaultmedia.user.url += '?rand=' + Math.random()
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style lang="scss">
.two-columns {
    display: grid;
    grid-template-columns: 180px 1fr !important;
    grid-column-gap: 24px;

    .col {
        img {
            max-width: 100%;
            max-height: 100%;
            border-radius: 8px;
        }
    }
}

.section-parameter .form-group input {
    &[type='file'] {
        display: none;
    }
}

.settings-image {
  width: 180px;
  height: 180px;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/settings_default_medias.vue